import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueGtag from 'vue-gtag'

import 'leaflet/dist/leaflet.css'
import config from '@/config/global.js'

Vue.config.productionTip = false
Vue.prototype.$config = Object.freeze(config)

Vue.use(
  VueGtag,
  {
    config: {
      id: process.env.VUE_APP_GAU_ID || '',
      params: {
        anonymize_ip: true
      }
    },
    enabled: false
  },
  router
)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
